// THIS FILE IS AUTOGENERATED. DO NOT EDIT
/* eslint-disable */
/* tslint:disable */
import * as apiRates from './apiRates'
export { apiRates }